import { AppBar, Box, Button, IconButton, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { COLORS } from '../Theme';
import React from 'react';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: 0,
		height: '93vh',
		width: '84vw',
		paddingTop: '7vh',
		background: `${COLORS.WHITE}`,
	},

	toolBar: {
		padding: 0,
	},
	back: {
		float: 'left',
		width: '20%',
		maxWidth: '75px',
	},
	titleWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		float: 'left',
		textAlign: 'center',
		width: '80%',
		minHeight: '4.5vh',
		// maxHeight: '4.5vh',
		justifyContent: 'center',
	},
	titleIcon: {
		width: '7vw',
		marginBottom: '1vw',
		maxWidth: '45px',
		[theme.breakpoints.up('md')]: {
			marginBottom: '0',
		},
	},
	title: {
		fontSize: '28px',
		color: `${COLORS.WATER_BLUE}`,
		marginLeft: '2vw',

		fontFamily: 'NanumR',
		fontWeight: 'bold',

		[theme.breakpoints.up('md')]: {
			marginLeft: '8px',
		},

		// marginBottom: '0.5vh',
		// alignItems: 'center',
		// flexGrow: 1,
		// textAlign: 'center',
	},
	title2: {
		color: `${COLORS.WATER_BLUE}`,
		marginLeft: '2vw',
		...theme.typography.h4,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		[theme.breakpoints.up('md')]: {
			...theme.typography.h1,
			color: `${COLORS.WATER_BLUE}`,
			fontFamily: 'NanumB',
			fontWeight: 'bold',
			marginLeft: '8px',
		},

		// marginBottom: '0.5vh',
		// alignItems: 'center',
		// flexGrow: 1,
		// textAlign: 'center',
	},
	button: {
		[theme.breakpoints.up('md')]: {
			padding: '1vw',
		},
		padding: '2vw',
		height: 'auto',
		borderRadius: '5px',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		color: `${COLORS.WHITE}`,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		...theme.typography.body1,
		fontFamily: 'NanumB',
		width: 'auto',
	},
}));

const TitleBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const { history, title, titleIcon, titleIconClass, rightButton } = props;

	return (
		<AppBar position="static" color="transparent" style={{ boxShadow: 'none' }}>
			<Toolbar className={clsx(classes.toolBar, classes.titleWrapper)} style={{ width: '100%', boxShadow: 'none' }}>
				{rightButton && <div style={{ flex: 1 }} />}

				<img className={titleIconClass || classes.titleIcon} src={`/images/title/${titleIcon}.webp`} />
				<Typography className={classes.title2} noWrap color="primary">
					{title}
				</Typography>

				{rightButton && <div style={{ flex: 1 }}>{rightButton}</div>}
			</Toolbar>
		</AppBar>
	);
};

export const TitleBackBar: React.FC<any> = (props) => {
	const classes = useStyles();
	const { history, title, titleIcon, titleIconClass } = props;

	return (
		<AppBar position="static" color="transparent" style={{ boxShadow: 'none' }}>
			<Toolbar className={classes.toolBar}>
				<Box display="flex" style={{ width: '100%', justifyContent: 'center' }}>
					<Box className={classes.back} onClick={() => history.goBack()}>
						<IconButton
							style={{
								width: '100%',
								height: '100%',
								margin: 'auto',
							}}
							data-testid="title-bar-back-btn"
						>
							<img style={{ width: '25%' }} src="/images/title/back.webp" />
						</IconButton>
					</Box>
					<Box className={classes.titleWrapper}>
						<img className={titleIconClass || classes.titleIcon} src={`/images/title/${titleIcon}.webp`} />
						<Typography className={classes.title2} variant="h4" noWrap color="primary">
							{title}
						</Typography>
					</Box>
					<Box className={classes.back}></Box>
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export const TitleBackBar2: React.FC<any> = (props) => {
	const classes = useStyles();
	const { history, title, titleIcon, titleIconClass } = props;

	return (
		<AppBar position="static" color="transparent" style={{ boxShadow: 'none' }}>
			<Toolbar className={classes.toolBar}>
				<Box display="flex" style={{ width: '100%' }}>
					<Box className={classes.back} onClick={() => history.goBack()}>
						<IconButton
							style={{
								width: '100%',
								height: '100%',
								margin: 'auto',
							}}
						>
							<img style={{ width: '25%' }} src="/images/title/back.webp" />
						</IconButton>
					</Box>
					<Box className={classes.titleWrapper}>
						<Typography
							className={classes.title2}
							style={{
								fontSize: '7vw',
								fontWeight: 'bold',
								marginLeft: '0vw',
							}}
							variant="h5"
							noWrap
							color="primary"
						>
							{title}
						</Typography>
					</Box>
					<Box className={classes.back}></Box>
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export const TitleBarWithButton: React.FC<any> = (props) => {
	const classes = useStyles();
	const { history, title, titleIcon, titleIconClass, buttonCheck, buttonText, buttonOnClick, buttonTestId } = props;

	return (
		<AppBar position="static" color="transparent" style={{ boxShadow: 'none', padding: '10px 0' }}>
			<Toolbar className={clsx(classes.toolBar, classes.titleWrapper)} style={{ width: '100%', boxShadow: 'none' }}>
				<div style={{ flex: 1 }}></div>
				<div
					style={{
						flex: 2,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<img className={titleIconClass || classes.titleIcon} src={`/images/title/${titleIcon}.webp`} />
					<Typography className={classes.title2} noWrap color="primary">
						{title}
					</Typography>
				</div>
				<div style={{ flex: 1 }}>
					{buttonCheck && (
						<Button className={classes.button} onClick={buttonOnClick} data-testid={buttonTestId || 'title-bar-button'}>
							{buttonText}
						</Button>
					)}
				</div>
			</Toolbar>
		</AppBar>
	);
};

export default TitleBar;
